import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { getTextCookies } from 'api/company';
// images
import Condiciones from 'assets/img/img_condiciones.png';
// components
import Head from 'components/metatags_helmet/metatags';
import NoResults from 'components/userzone/NoResults';
import './infoPages.scss';

const Cookies = () => {
  const [textCookies, setTextCookies] = useState({});
  const { t, i18n } = useTranslation(['footer']);
  const title = t('cookies');

  const getCookiesText = async () => {
    const { status, data } = await getTextCookies();
    console.log(data);
    if (status === 200) {
      setTextCookies(data[0]);
    }
  };

  useEffect(() => {
    getCookiesText();
  }, []);

  return (
    <div className="container-fluid mainDiv">
      <Head title={title} noIndex={true} />
      {textCookies && Object.keys(textCookies).length ? (
        <Row className="justify-content-center mainRow infoRow">
          <Col lg={8} className="mt-4">
            <div className="row">
              <div className="col-md-12">
                <h1 className="infoTitle"> {textCookies[`title_${i18n.language}`] || textCookies.title}</h1>
                <hr />
              </div>
            </div>
            <div className="row">
              <div
                className="col-md-12"
                id="static-content"
                dangerouslySetInnerHTML={{
                  __html: textCookies[`text_${i18n.language}`] || textCookies.text,
                }}
              ></div>
            </div>
          </Col>
          <Col lg={3} className="d-flex justify-content-center align-items-start mt-4 pr-0 pt-lg-4">
            <img src={Condiciones} alt="paper.png" className="infoImg" />
          </Col>
        </Row>
      ) : (
        <NoResults className="noFavorites" />
      )}
    </div>
  );
};

export default Cookies;
